import React from 'react';
import { Modal, Box } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CustomButton from 'shared/custom-button/CustomButton';

interface ModalWidgetProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: React.ReactNode;
  closeIconPosition?: 'left' | 'right';
  showAcceptButton?: boolean;
  showCancelButton?: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
  acceptButtonText?: string;
  cancelButtonText?: string;
  widthProps?: number;
}

const ModalWidget: React.FC<ModalWidgetProps> = ({
  open,
  handleClose,
  title,
  children,
  closeIconPosition = 'right',
  showAcceptButton = false,
  showCancelButton = false,
  onAccept,
  onCancel,
  acceptButtonText = 'Принять',
  cancelButtonText = 'Отменить',
  widthProps = 400
}) => {
  const handleAccept = () => {
    onAccept?.(); 
  };

  const handleCancel = () => {
    onCancel ? onCancel() : handleClose(); 
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: widthProps,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 1,
        borderRadius: '4px',
        border: 'none'
      }}>
        <Box sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          {closeIconPosition === 'left' && (
            <CustomButton
              icon={CloseOutlinedIcon}
              handleClick={handleClose}
              border="none"
              textColor="#0054E6"
            />
          )}
          
          <Box sx={{
            color: '#6F879C',
            fontSize: '18px',
            width: '100%',
            textAlign: 'center',
          }}>
            {title}
          </Box>
          
          {closeIconPosition === 'right' && (
            <CustomButton
              icon={CloseOutlinedIcon}
              handleClick={handleClose}
              textColor="#0054E6"
              border="none"
            />
          )}
        </Box>

        <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {children}
        </Box>

        {(showAcceptButton || showCancelButton) && (
          <Box sx={{
            mt: 4,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
          }}>
            {showCancelButton && (
              <CustomButton
                handleClick={handleCancel} 
                title={cancelButtonText}
                padding="0 10px"
                gap="10px"
                borderRadius='4px'
                textColor="#0054E6"
                border="none"
              />
            )}
            
            {showAcceptButton && (
              <CustomButton
                handleClick={handleAccept} 
                title={acceptButtonText}
                padding="0 40px"
                backgroundColor="#0054E6"
                textColor="white"
                borderRadius='4px'
              />
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default ModalWidget;